import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { documentTypes, clientTypes } from './create-client-data';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getClient, updateClient } from '../../actions/client-actions';
import { provinces } from '../../actions/global-actions-data';

function EditClient(){
    const currentLink = "/clientes";
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loadData, setLoadData] = useState(true);
    const params = useParams();
    const user = useSelector(state => state.user.user);

    const [form, setForm] = useState({
        firstName: '',
        lastName: '',
        documentType: 'CC',
        document: '',
        clientType: 'natural',
        email: '',
        manager: '',
        managerDocumentType: 'CC',
        managerDocument: '',
        managerEmail: '',
        province: '',
        city: ''
    });

    const [citiesData, setCitiesData] = useState([]);

    /*
    const caseGroup = {
        position: '',
        statePosition: '',
        executionCity: '',
    }

    const [form, setForm] = useState({
        firstName: '',
        lastName: '',
        documentType: '',
        document: '',
        email: '',
        cases: [
            {
                position: '',
                statePosition: '',
                executionCity: '',
            }
        ]
    });
    */

    useEffect(() => {
        if (loadData) {
            const getFunction = (data) => {
                if(data.code === "01"){
                    Swal.fire({
                        title:"Error",
                        confirmButtonColor:"#76b4ff",
                        text: data.message
                    });
                }else{
                    //console.log('data', data.data[0]);
                    if(data.data[0].province) {
                        setCitiesData(provinces.find(province=>province.name===data.data[0].province).cities);
                    }
                    setForm({
                        ...form,
                        ...data.data[0]
                    })
                }
            }

            setLoadData(false);
            setForm({
                firstName: '',
                lastName: '',
                documentType: 'CC',
                document: '',
                clientType: 'natural',
                email: '',
                manager: '',
                managerDocumentType: 'CC',
                managerDocument: '',
                managerEmail: '',
                province: '',
                city: ''
            });
            dispatch( getClient( params.id, getFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, form, user.token ]);

    /*
    const addGroup = () => {
        form.cases.push(caseGroup);
        setForm({...form})
    }

    const deleteItem = (index) => {
        if (form.cases.length > 1) {
            form.cases.splice(index, 1);
            setForm({...form})   
        }
    }

    const handleItemChange = (event, index) => {
        form.cases[index][event.target.name] = event.target.value;
        setForm({...form})
    }

    const renderCases = () => {
        return (
            <div>
                <h4 className="w-100 my-2">Casos</h4>
                {form.cases.map( (itemCase, index) => (
                    <div key={index} className="d-flex w-100 flex-wrap position-relative">
                        <div  className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor={'position-' + index}>Cargo <b>{index + 1}</b></label>
                            <input id={'position-' + index} name={'position'} autoComplete="off" maxLength={100} className="input-field" type="text" onChange={(e) => handleItemChange(e, index)} value={itemCase.position}></input>
                        </div>
                        <div  className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor={'state-position-' + index}>Estado del cargo</label>
                            <input id={'state-position-' + index} name={'statePosition'} autoComplete="off" maxLength={100} className="input-field" type="text" onChange={(e) => handleItemChange(e, index)} value={itemCase.statePosition}></input>
                        </div>
                        <div  className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor={'execution-city-' + index}>Ciudad de ejecución</label>
                            <input id={'execution-city-' + index} name={'executionCity'} autoComplete="off" maxLength={100} className="input-field" type="text" onChange={(e) => handleItemChange(e, index)} value={itemCase.executionCity}></input>
                        </div>
                        <button className="delete-button" type="button" onClick={() => deleteItem(index)}>&#120;</button>
                    </div>
                ))}
                <div className="w-100 d-flex d-flex justify-content-center my-4">
                    <button className="add-icon-button" type="button" onClick={addGroup}>&#43;</button>
                </div>
            </div>
        )
    }
    */

    const handleInputChange = (event) => {
        if (event.target.name === 'clientType' && event.target.value === 'juridica') {
            setForm({
                ...form,
                manager: '',
                managerDocumentType: 'CC',
                managerDocument: '',
                managerEmail: '',
                [event.target.name] :  event.target.value
            })
        } else {
            setForm({
                ...form,
                [event.target.name] :  event.target.value
            })
        }
    }

    const handleOnChange = (event, position) => {
        const value = event.target.value;
        if (value !== '' && value) {
            const cities = provinces.find( x => x.name === value).cities;
            setCitiesData(cities);
            setForm({
                ...form,
                [event.target.name]: event.target.value
            })
            return;
        }

        setCitiesData([])
        setForm({
            ...form,
            city :  '',
            province: ''
        })
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar todos los datos para continuar"
            });
            return;
        } else {
            if (form.clientType === 'natural') {
                form.manager = '';
                form.managerDocumentType = '';
                form.managerDocument = '';
                form.managerEmail = '';
            }

            dispatch( updateClient( form, updateFunction, user.token ) );
        }
    }

    const validateFields = () => {
        if (form.clientType === 'natural') {
            for (const field in form) {
                if (form.hasOwnProperty(field)) {
                    //console.log(`${field}: ${form[field]}`);
                    if ( field !== 'manager' && field !== 'managerDocumentType' && field !== 'managerDocument' && field !== 'managerEmail' && form[field] === '') {
                        return true
                    }
                }
            }
        } else {
            for (const field in form) {
                if (form.hasOwnProperty(field)) {
                    //console.log(`${field}: ${form[field]}`);
                    if ( form[field] === '' ) {
                        return true
                    }
                }
            }
        }
        return false
    }

    const updateFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            navigate(currentLink)
            //console.log(data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Cliente actualizado con éxito"
            });
        }
    }

    useEffect(() => {
        //console.log(form);
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Editar cliente</h1>
                <form onSubmit={handleOnSubmit}>
                    <div className="d-flex w-100 flex-wrap">
                        <h4 className="w-100 mb-2">Datos generales</h4>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="firstName">Nombres</label>
                            <input id="firstName" name="firstName" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange} value={form.firstName}></input>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="lastName">Apellidos</label>
                            <input id="lastName" name="lastName" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange} value={form.lastName}></input>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="documentType">Tipo de documento</label>
                            <select className="input-field" id="documentType" name="documentType" onChange={handleInputChange} value={form.documentType}>
                                <option></option>
                                {documentTypes.map((documentType, index) => (
                                    <option key={index} value={documentType.value}>{documentType.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="document">Documento</label>
                            <input id="document" name="document" autoComplete="off"  maxLength={15} className="input-field" type="number" onChange={handleInputChange} value={form.document}></input>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="email">Email</label>
                            <input id="email" name="email" autoComplete="off" maxLength={120} className="input-field" type="email" onChange={handleInputChange} value={form.email}></input>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="clientType">Tipo de cliente</label>
                            <select className="input-field" id="clientType" name="clientType" onChange={handleInputChange} value={form.clientType}>
                                <option></option>
                                {clientTypes.map((clientType) => (
                                    <option key={clientType.value} value={clientType.value}>{clientType.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="province">Departamento de residencia</label>
                            <select className="input-field" id="province" name="province" onChange={handleOnChange} value={form.province}>
                                <option></option>
                                {provinces.map((province) => (
                                    <option key={province.name} value={province.name}>{province.name}</option>
                                ))}
                            </select>
                        </div>
                        {form.province !== '' && citiesData && citiesData !== [] ? 
                            <div className="d-flex flex-column w-3 field">
                                <label className="label-field" htmlFor="city">Ciudad de residencia</label>
                                <select className="input-field" id="city" name="city" onChange={handleInputChange} value={form.city}>
                                    <option></option>
                                    {citiesData.map((city) => (
                                        <option key={city.name} value={city.name}>{city.name}</option>
                                    ))}
                                </select>
                            </div>
                            :''}
                        {form.clientType === 'juridica' ? 
                            <div className="d-flex w-100 flex-wrap">
                                <h4 className="w-100 mb-2">Representante legal</h4>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="manager">Representante</label>
                                    <input id="manager" name="manager" autoComplete="off" maxLength={200} className="input-field" type="text" onChange={handleInputChange} value={form.manager}></input>
                                </div>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="managerDocumentType">Tipo de documento</label>
                                    <select className="input-field" id="managerDocumentType" name="managerDocumentType" onChange={handleInputChange} value={form.managerDocumentType}>
                                        <option></option>
                                        {documentTypes.map((documentType, index) => (
                                            <option key={index} value={documentType.value}>{documentType.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="managerDocument">Documento</label>
                                    <input id="managerDocument" name="managerDocument" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange} value={form.managerDocument}></input>
                                </div>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="managerEmail">Email</label>
                                    <input id="managerEmail" name="managerEmail" autoComplete="off" maxLength={120} className="input-field" type="email" onChange={handleInputChange} value={form.managerEmail}></input>
                                </div>
                            </div>
                         : ''}
                        <div className="w-100 d-flex justify-content-center my-4">
                            <button className="primary-button save-button" type="submit">Guardar &#43;</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditClient;
  